$(document).ready(function(e){

    // Because of the way CheckboxSetField is constructed, 
    // we're not actually able to validate it properly using jQuery validate.
    // This is because every input in the list has a different name.
    // So, we add a hidden field which gets updated when the checkboxes change value,
    // and that hidden field is read for validation.
    // Hacky, I know, but it works.

    if($(document).find('.checkboxset-required-fields')){

        $(document).find('.checkboxset-required-fields').each(function(){

            var inputs = $(this).find('input.checkbox');
            var hidden_field = $(this).find('.validation-proxy');
            
            // we only want to require js validation on this hidden field if it's "real" field is visible
            if($(this).is(':visible')){
                hidden_field.addClass('validate-hidden');
            }else {
                hidden_field.removeClass('validate-hidden');
            }

            if($(this).find('input.checkbox:checked').length){
                console.info($(this).find('input.checkbox:checked'));
                hidden_field.attr('value', 'valid');
            }else {
                hidden_field.attr('value', '');
            }     

            inputs.each(function(){
                var parent = $(this).parents('.checkboxset-required-fields');
                $(this).change(function(){
                    if(parent.find('input.checkbox:checked').length){
                        hidden_field.attr('value', 'valid');
                    }else {
                        hidden_field.attr('value', '');
                    }
                });
                $(this).rules(
                    "add", {
                        required: function(element) {
                            var fail = true;
                            // return true if the field has FAILED validation checks
                            // return false if the field has PASSED validation checks
                            // Man that's confusing as. But anyway...
                            // In this case we setting the value of a hidden field (slightly hacky)
                            // to validate on, as the Checkboxet field cannot (easily) be directly validated
                            if(hidden_field.val()){
                                fail = false;
                            }
                            // Every input in the set appends an error message.
                            // We only want one error message, so remove all first
                            parent.find('div.error').remove();
        
                            return fail;
                        },
                        messages: {						
                            required: 'Please select at least one of these options'
                        }
                    }
                );
            });

        });  
	
	}


	
});